const routeBars = [
  { name: "主入口", value: 92, color: "bg-emerald-500" },
  { name: "备用线路 A", value: 76, color: "bg-emerald-500" },
  { name: "备用线路 B", value: 48, color: "bg-amber-500" },
  { name: "永久地址", value: 99, color: "bg-emerald-500" },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-stone-200/70 bg-[#fbf7f0]">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-orange-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-amber-100/60 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 lg:grid-cols-12 lg:gap-8 lg:py-20">
        {/* 文案为主 */}
        <div className="lg:col-span-7">
          <div className="mb-5 inline-flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold text-orange-700">
              <i className="ri-focus-3-line"></i> 备用地址已置顶
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-white px-3 py-1 text-xs font-medium text-stone-600">
              <i className="ri-refresh-line"></i> 实时同步最新入口
            </span>
          </div>

          <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-stone-900 md:text-5xl">
            吃瓜线路，
            <br className="hidden md:block" />
            找得到 <span className="relative inline-block text-orange-600">
              才看得到
              <svg className="absolute -bottom-1 left-0 w-full" height="8" viewBox="0 0 120 8" fill="none" preserveAspectRatio="none">
                <path d="M2 6C30 2 60 1 118 4" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-600 md:text-lg">
            主入口偶尔波动很正常。把本站记进收藏，一旦失联，回到这里就能拿到最新备用地址与永久地址，
            <strong className="font-semibold text-stone-800">一键切换、不再走丢</strong>。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#entrance"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-orange-600 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-orange-700"
            >
              进入最新入口 <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#collection"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-stone-300 bg-white px-6 py-3 text-base font-semibold text-stone-700 transition-colors hover:border-orange-300 hover:text-orange-700"
            >
              <i className="ri-bookmark-line text-lg"></i> 先逛逛专题
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-stone-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-emerald-600"></i> 永久地址
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-emerald-600"></i> 防屏蔽
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-timer-line text-emerald-600"></i> 多线路实时切换
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-thunderstorms-line text-emerald-600"></i> 最新入口更新中
            </span>
          </div>
        </div>

        {/* 视觉陪衬：通道体检卡 */}
        <div className="lg:col-span-5">
          <div className="rounded-xl border border-stone-200 bg-white p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-sm font-bold text-stone-800">通道体检 · 实时</h2>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                稳定
              </span>
            </div>

            <div className="mt-5 flex flex-col gap-4">
              {routeBars.map((r) => (
                <div key={r.name}>
                  <div className="mb-1.5 flex items-center justify-between text-xs">
                    <span className="font-medium text-stone-600">{r.name}</span>
                    <span className="font-semibold text-stone-800">{r.value}%</span>
                  </div>
                  <div className="h-2 w-full overflow-hidden rounded-full bg-stone-100">
                    <div className={`h-full rounded-full ${r.color}`} style={{ width: `${r.value}%` }}></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 flex items-center justify-between rounded-lg border border-stone-200 bg-[#fbf7f0] px-3.5 py-3">
              <div className="min-w-0">
                <p className="text-[11px] font-medium text-stone-500">当前推荐入口</p>
                <p className="truncate font-mono text-sm font-bold text-stone-900">chigua-line.app</p>
              </div>
              <div className="flex shrink-0 gap-1.5">
                <button type="button" className="flex h-8 w-8 items-center justify-center rounded-md border border-stone-300 bg-white text-stone-600 transition-colors hover:text-orange-600" aria-label="复制">
                  <i className="ri-file-copy-line text-sm"></i>
                </button>
                <a href="#entrance" className="flex h-8 items-center gap-1 whitespace-nowrap rounded-md bg-orange-600 px-2.5 text-xs font-semibold text-white transition-colors hover:bg-orange-700" aria-label="打开">
                  前往 <i className="ri-external-link-line text-xs"></i>
                </a>
              </div>
            </div>

            <p className="mt-4 text-xs leading-relaxed text-stone-400">
              通道状态每分钟自动刷新。若入口波动，体检数值会同步变化，请以公告栏最新提示为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}